const TOKEN_KEY = 'tctp:token';
const NICK_KEY = 'tctp:nickname';
const MONITOR_KEY = 'tctp:monitorKey';
let memoryToken: string | null = null;

function randomToken(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
}

function storage(): Storage | null {
  try {
    const s = window.localStorage;
    s.getItem(TOKEN_KEY);
    return s;
  } catch {
    return null;
  }
}

/** The per-browser session token: this browser's identity in every room. */
export function sessionToken(): { token: string; persistent: boolean } {
  const s = storage();
  if (!s) {
    memoryToken ??= randomToken();
    return { token: memoryToken, persistent: false };
  }
  let token = s.getItem(TOKEN_KEY);
  if (!token || !/^[0-9a-f]{32}$/.test(token)) {
    token = randomToken();
    s.setItem(TOKEN_KEY, token);
  }
  return { token, persistent: true };
}

export function rememberedNickname(): string {
  return storage()?.getItem(NICK_KEY) ?? '';
}

export function rememberNickname(nickname: string): void {
  storage()?.setItem(NICK_KEY, nickname);
}

/** The operator monitor's key, kept until the server rejects it. */
export function storedMonitorKey(): string | null {
  return storage()?.getItem(MONITOR_KEY) ?? null;
}

export function storeMonitorKey(key: string | null): void {
  const s = storage();
  if (!s) return;
  if (key === null) s.removeItem(MONITOR_KEY);
  else s.setItem(MONITOR_KEY, key);
}
